export default __webpack_public_path__ + "resources/icons/d110-37c9.webp";